// extracted by mini-css-extract-plugin
export default {"header":"EmailView_header__3RuAZ","referral":"EmailView_referral__ifkh2","referralText":"EmailView_referralText__BWbUY"};